import { useQueryClient } from '@tanstack/react-query';
import { LogOut, UserRound } from 'lucide-react';
import { type ReactNode, useState } from 'react';
import { Link, useNavigate } from 'react-router';
import { paths } from '@/shared/lib/paths';
import { ConfirmDialog } from '@/shared/ui/confirm-dialog';
import { notifyError } from '@/shared/ui/notify';
import { Button } from '@/shared/ui/primitives/button';
import { useSession } from '../hooks/use-session';
import { endAllSessions, endSession } from '../session';

/** Nome do usuário, "Meu perfil" (com troca de senha), sair e sair de todos os dispositivos. */
export function UserMenu(): ReactNode {
  const displayName = useSession((state) => state.session?.displayName);
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const [confirmAll, setConfirmAll] = useState(false);

  return (
    <div className="flex flex-wrap items-center gap-3">
      <span className="text-sm text-muted-foreground">{displayName}</span>
      <Button asChild variant="ghost" size="sm">
        <Link to={paths.profile()}>
          <UserRound aria-hidden className="size-4" />
          Meu perfil
        </Link>
      </Button>
      <Button
        variant="ghost"
        size="sm"
        onClick={() => {
          setConfirmAll(true);
        }}
      >
        Sair de todos os dispositivos
      </Button>
      <Button
        variant="outline"
        size="sm"
        onClick={() => {
          void endSession(queryClient).then(() => navigate(paths.login()));
        }}
      >
        <LogOut aria-hidden className="size-4" />
        Sair
      </Button>
      <ConfirmDialog
        open={confirmAll}
        onOpenChange={setConfirmAll}
        title="Sair de todos os dispositivos?"
        description="Todas as sessões abertas com a sua conta, inclusive esta, serão encerradas."
        confirmLabel="Sair de todos"
        onConfirm={() => {
          void endAllSessions(queryClient)
            .then(() => navigate(paths.login()))
            .catch((error: unknown) => {
              notifyError(error, 'Não foi possível encerrar as sessões');
            });
        }}
      />
    </div>
  );
}
